/**
 * Status label policy (BUG-003): **show API values as returned** — no rewriting for title case / synonyms.
 * Visual consistency comes from {@link ../../design-system/molecules/StatusBadge.jsx StatusBadge}
 * plus {@link ./statusVariant.js getStatusVariant} for chip color only.
 */

/**
 * Label text inside status chips. Empty / whitespace-only payloads render as an em dash.
 *
 * @param {unknown} status
 * @returns {string}
 */
export function getStatusDisplayLabel(status) {
  if (status == null) return "—";
  const raw = typeof status === "string" ? status : String(status);
  return raw.trim() === "" ? "—" : raw;
}
